import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import PopupWrapper from "../components/PopupWrapper";
import { withCookies } from "react-cookie";
import EmailReportSettings from "../components/EmailReportSettings";
import AccountSubheader from "../components/AccountSubheader";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { accountActions } from "../_actions";
import AccountBackButton from "../components/AccountBackButton";

class AccountInfoCareEmailReport extends Component {
  constructor(props) {
    super(props);

    let user = JSON.parse(localStorage.getItem("user"));
    if (!user.user_id) {
      user.user_id = user.dependant_user_id;
    }
    this.props.dispatch(accountActions.getEnergyDetail(user));
  }
  submitEmail = (values) => {
    let email_report;
    if (values.email_report == "never") {
      email_report = 0;
    } else if (values.email_report == "daily") {
      email_report = 1;
    } else if (values.email_report == "weekly") {
      email_report = 2;
    } else if (values.email_report == "monthly") {
      email_report = 3;
    }

    this.props.dispatch(accountActions.setEmail(email_report));
  };
  render() {
    const { account } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>

        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backHref="/account/infocare/"
            backLabel="InfoCare"
            title="Email Report"
          />
          <EmailReportSettings onSubmit={this.submitEmail} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let initialValues = {};

  return {
    initialValues,
    ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "account", // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    enableReinitialize: true,
  })(withCookies(AccountInfoCareEmailReport))
);
